export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation of an electronic check"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deposit Account"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Series"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation Code"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate Electronic Check"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amount"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelled"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activating"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Returning"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pending"])}
  }
}